import { useState, useEffect } from "react";

const useTotalPrice = (
    selectedFlight,
    selectedIntFlight,
    domesticFlightInformation,
    selectedHotel,
    selectedRooms,
    hotelPassengers,
    selectedBus,
    busPassengers,
) => {
    const [totalPrice, setTotalPrice] = useState(0);

    const isTwoWay = domesticFlightInformation?.returnDate;

    useEffect(() => {
        const calculateFlightPrice = (flight, passengers) => {
            if (flight?.tag === "pr" || flight?.tag === "ch118") {
                return flight?.total_price || 0;
            }
            if (flight?.tag === "zm") {
                return (flight?.adult_price || 0) * (passengers?.adult || 0) + (flight?.child_price || 0) * 0 + (flight?.infant_price || 0) * 0;
            }
            return (
                (flight?.adult_price || 0) * (passengers?.adult || 0) +
                (flight?.child_price || 0) * (passengers?.child || 0) +
                (flight?.infant_price || 0) * (passengers?.infant || 0)
            );
        };

        const calculateHotelPrice = rooms => {
            return rooms?.reduce((total, room) => total + room.prices.total_price * room.count, 0) || 0;
        };

        const calculateExtendPrice = passengers => {
            return passengers?.passengers?.reduce((total, passenger) => total + (passenger.extend_price ? +passenger.extend_price : 0), 0) || 0;
        };

        //domestic price
        const oneWayFlightPrice = calculateFlightPrice(selectedFlight, domesticFlightInformation?.personCounter);
        const twoWayFlightPrice = selectedFlight?.fares?.total_price;
        const domesticFlightPrice = !!isTwoWay && !!selectedFlight ? twoWayFlightPrice : oneWayFlightPrice;
        const hotelPrice = selectedHotel === "pr" ? selectedRooms?.fare.total || 0 : calculateHotelPrice(selectedRooms);
        const hotelExtendPrice = calculateExtendPrice(hotelPassengers);
        //international price
        const intFlightPrice = selectedIntFlight?.fares?.total_price || 0;
        //bus
        const busPrice = selectedBus?.price * busPassengers?.passengers?.length || 0;

        //total price
        const total = domesticFlightPrice + intFlightPrice + hotelPrice + hotelExtendPrice + busPrice;
        setTotalPrice(total);
    }, [selectedFlight, selectedIntFlight, selectedRooms, hotelPassengers, domesticFlightInformation]);

    return totalPrice;
};

export default useTotalPrice;
